<template>
  <div class="container" >
      <div class="row">
          <div class="col">
            <button @click="()=>show=!show" type="button" class="btn btn-warning" v-if="differents.length>0 ">
              <i :class="`fa ${show?'fa fa-angle-double-up': 'fa fa-angle-double-down'}`"></i>
              {{ differents.length }} item berbeda
          </button>
          </div>
      </div>
      <div class="row" v-show="show">
            <div class="col" v-if="sourceData.table_name=='app_finances'">
                <div class="container">
                  <div class="row">
                    <div class="col" 
                      v-for="(item, index) in Object.keys(sourceData.old_value)" :key="index" 
                      v-if="sourceData.old_value[item]!==sourceData.new_value[item] "
                      >
                      {{ item }} : {{ sourceData.old_value[item] }} vs {{ sourceData.new_value[item] }}
                    </div>
                  </div>
                </div>

            </div>
            <div class="col" v-else-if="sourceData?.table_name=='financial_balance'">
                <div class="container">
                  <div class="row">
                    <div class="col" 
                      v-for="(item, index) in Object.keys(sourceData.old_value)" :key="index" 
                      v-if="sourceData.old_value[item]!==sourceData.new_value[item] "
                      >
                      {{ item }} : {{ sourceData.old_value[item] }} vs {{ sourceData.new_value[item] }}
                    </div>
                  </div>
                </div>

            </div>
            <div class="col" v-else-if="sourceData?.table_name=='financial_balance_history'">
                <div class="container">
                  <div class="row">
                    <div class="col" 
                      v-for="(item, index) in Object.keys(sourceData.old_value)" :key="index" 
                      v-if="sourceData.old_value[item]!==sourceData.new_value[item] "
                      >
                      {{ item }} : {{ sourceData.old_value[item] }} vs {{ sourceData.new_value[item] }}
                    </div>
                  </div>
                </div>

            </div>
            <div class="col" v-else>
                -

            </div>
          </div>
        </div>
</template>

<script>
  // import { component as VueNumber } from '@coders-tm/vue-number-format'

  export default {
    name: 'LogDetail',
    components: {
      // VueNumber,
    },
    props: {
        type:'',
        sourceData: {
          type: Object, 
          default: ()=>{}
        },
    },

    data() {
      return {
        show: false
      }
    },
    computed: {
        differents: function () {
          if (this.sourceData.old_value) {
            return Object.keys(this.sourceData.old_value).filter((index)=>{
              return this.sourceData.old_value[index]!==this.sourceData.new_value[index]
            })
            
          }
          return []
        }
    },
  }
</script>